import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export interface CaseStudy {
  id: string;
  title: string;
  thumbnail_url: string;
  created_at: string;
  url: string;
  org_logo: string;
  org_name: string;
}

@Component({
  selector: 'hub-case-studies-list',
  templateUrl: './hub-case-studies-list.component.html',
  styleUrls: ['./hub-case-studies-list.component.scss']
})
export class HubCaseStudiesListComponent implements OnInit {
  caseStudies: CaseStudy[] = [];

  constructor(private _http: HttpClient) {}

  ngOnInit(): void {
    this.getLatestUseCases();
  }

  async getLatestUseCases() {
    await this._http
      .get(environment.latestUseCaseFile)
      .toPromise()
      .then((data: any) => {
        this.caseStudies = this.parseCaseStudies(data);
      });
  }
  parseCaseStudies(data: any): CaseStudy[] {
    return data?.items.map((item: any) => {
      const client = item.fieldData.client;
      return {
        id: item.id,
        title: item.fieldData.title,
        thumbnail_url: item.fieldData.poster.url,
        created_at: "",
        url: `https://wonda.pro/case-studies/${item.fieldData.slug}`,
        org_logo: client && client.logo?.url || "",
        org_name: client && client.name || ""
      }
    })
  }
}
